module.exports = new __parcel__URL__("chainsofice.3e6c97ad.png").toString();